import {
  Box,
  Card,
  CardContent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function ResponsiveTable({
  rows,
  columns,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  getRowId,
  getCardTitle,
  emptyText = "Sin registros",
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const paginatedRows = rows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (!rows.length) {
    return (
      <Box
        sx={{
          px: 2,
          py: 5,
          textAlign: "center",
          border: "1px dashed rgba(0,0,0,0.12)",
          borderRadius: "18px",
          backgroundColor: "background.paper",
        }}
      >
        <Typography sx={{ color: "text.secondary" }}>
          {emptyText}
        </Typography>
      </Box>
    );
  }

  if (isMobile) {
    return (
      <Box>
        <Stack spacing={1.25}>
          {paginatedRows.map((row) => (
            <Card
              key={getRowId(row)}
              elevation={0}
              sx={{
                borderRadius: "18px",
                border: "1px solid rgba(140,15,44,0.12)",
              }}
            >
              <CardContent sx={{ p: 1.6 }}>
                {getCardTitle && (
                  <Typography
                    sx={{
                      fontSize: "1rem",
                      fontWeight: 700,
                      color: "text.primary",
                      mb: 1.2,
                    }}
                  >
                    {getCardTitle(row)}
                  </Typography>
                )}

                <Stack spacing={1.05}>
                  {columns.map((column) => (
                    <Box key={column.key}>
                      <Typography
                        sx={{
                          fontSize: "0.78rem",
                          fontWeight: 700,
                          color: "text.secondary",
                          mb: 0.35,
                        }}
                      >
                        {column.label}
                      </Typography>

                      <Box
                        sx={{
                          fontSize: "0.92rem",
                          color: "text.primary",
                        }}
                      >
                        {column.render
                          ? column.render(row)
                          : row[column.key]}
                      </Box>
                    </Box>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>

        <TablePagination
          component="div"
          count={rows.length}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Filas"
        />
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer
        sx={{
          borderRadius: "18px",
          border: "1px solid rgba(140,15,44,0.12)",
          backgroundColor: "background.paper",
          overflow: "hidden",
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "primary.main",
              }}
            >
              {columns.map((column) => (
                <TableCell
                  key={column.key}
                  sx={{
                    fontWeight: 700,
                    color: "#fff",
                    fontSize: "0.9rem",
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedRows.map((row) => (
              <TableRow
                key={getRowId(row)}
                hover
                sx={{
                  transition: "all .12s ease",
                  "&:hover": {
                    backgroundColor:
                      "rgba(140,15,44,0.05)",
                  },
                }}
              >
                {columns.map((column) => (
                  <TableCell
                    key={column.key}
                    sx={{
                      fontSize: "0.92rem",
                    }}
                  >
                    {column.render
                      ? column.render(row)
                      : row[column.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Filas"
      />
    </Box>
  );
}